import { useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Mail, X } from "lucide-react";
import { apiErrorMessage } from "../lib/errors";

/** Non-blocking banner asking verified users to confirm their email. */
export default function EmailVerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent — check your inbox");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Could not send"));
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="email-verify-banner"
      className="bg-amber-500/10 border-b border-amber-500/40 px-6 py-3 flex items-center justify-between gap-4 text-xs mono"
    >
      <div className="flex items-center gap-2 text-amber-300">
        <Mail size={14} strokeWidth={1.5} />
        <span>
          VERIFY YOUR EMAIL TO RECEIVE THE MORNING DIGEST AND SECURE YOUR ACCOUNT.
        </span>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={resend}
          disabled={sending}
          data-testid="email-verify-resend"
          className="uppercase tracking-widest text-amber-400 hover:text-amber-200 disabled:opacity-50"
        >
          {sending ? "Sending..." : "Resend"}
        </button>
        <button
          onClick={() => setDismissed(true)}
          data-testid="email-verify-dismiss"
          aria-label="Dismiss"
          className="text-amber-500 hover:text-amber-200"
        >
          <X size={14} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}